import { HStack, Icon, Link, type LinkProps, useColorModeValue as mode, Text } from '@chakra-ui/react';
import React, { type FunctionComponent } from 'react';
import { type IconType } from 'react-icons';
import { IoLogOutOutline } from 'react-icons/io5';
import { useLocation, useResolvedPath } from 'react-router-dom';

interface NavLinkProps extends LinkProps {
    isActive?: boolean;
    label: string;
    icon: IconType;
    to?: string;
}

export const NavLink: FunctionComponent<NavLinkProps> = (props: NavLinkProps) => {
    const { pathname } = useLocation();
    const { icon, label, ...rest } = props;
    const isActive = rest.to && pathname === useResolvedPath(rest.to).pathname;

    return (
        <Link
            display="block"
            py="2"
            px="3"
            borderRadius="md"
            transition="all 0.3s"
            fontWeight="medium"
            fontSize="sm"
            userSelect="none"
            aria-current={isActive ? 'page' : undefined}
            _hover={{
                bg: mode('gray.100', 'gray.700'),
                color: mode('gray.900', 'white'),
                textDecoration: 'none',
            }}
            _activeLink={{
                bg: mode('gray.200', 'gray.700'),
                color: 'inherit',
            }}
            {...rest}
        >
            <HStack spacing="4">
                <Icon as={icon} fontSize="lg" opacity={0.64} />
                <Text as="span" flex="1">
                    {label}
                </Text>
                {rest.isExternal && <IoLogOutOutline />}
            </HStack>
        </Link>
    );
};
